<template>
    <div class="main">
        <c-panel>
            <form-documento></form-documento>
        </c-panel>
    </div>
</template>
<script>

import formDocumento from "./form"

export default {
    components:{ 'form-documento': formDocumento }
}
</script>
